/**
 * Operational event names.
 */
export const OPERATIONAL_EVENTS = {
  SDK_LOADING: 'cmp_sdk_loading',
  SDK_LOADED: 'cmp_sdk_loaded',
  SDK_LOAD_FAILED: 'cmp_sdk_load_failed',
  CONSENT_ACCEPT_ALL: 'consent_accept_all',
  CONSENT_REJECT_ALL: 'consent_reject_all',
  CONSENT_UPDATE_FAILED: 'consent_update_failed',
  MANAGE_SETTINGS_CLICKED: 'consent_manage_settings_clicked',
  BANNER_SHOW_REQUESTED: 'consent_banner_show_requested',
  BANNER_HIDE_REQUESTED: 'consent_banner_hide_requested',
  FALLBACK_APPLIED: 'consent_fallback_applied',
  COOKIE_POLICY_LINK_CLICKED: 'consent_cookie_policy_link_clicked',
  VENDORS_LINK_CLICKED: 'consent_vendors_link_clicked',
  PRIVACY_SETTINGS_LINK_CLICKED: 'consent_privacy_settings_link_clicked',
} as const;
